import React, { useState } from 'react';
import { userIcon, bmsLogo } from './Images';
import '../css/header.css';
import UserMenu from './UserMenu';
import OutsideClickHandler from './OutsideClickHandler';

const Header = () => {

    const [userMenu, setUserMenu] = useState(false);
    const showUserMenu = () => {
        setUserMenu(!userMenu);
    }
    const handleOutsideClick = () => {
        setUserMenu(false);
    }
    return (
        <>
            <header className='home-header'>
                <div className='logo-section'>
                    <img src={bmsLogo} alt="" className='bms-logo' />
                </div>
                <OutsideClickHandler onOutsideClick={handleOutsideClick}>
                    <button className='user-actions-btn' onClick={showUserMenu}>
                        <div className='btn-icon'>
                            <img src={userIcon} alt="" className='img-icon' />
                        </div>
                        <div className='btn-legend'>
                            Usuario
                        </div>
                    </button>
                    { userMenu && <UserMenu /> }
                </OutsideClickHandler> 
            </header>         
        </>
    );
}

export default Header;
